import React from "react";
import { Global } from "@sourceflow-uk/sourceflow-sdk";
import { SourceFlowHead } from "@sourceflow-uk/sourceflow-head";
import metaObject from "@/.sourceflow/metadata.json";
import sourceflowEnums from "@/sourceflow.enums";
import ReadyCTABanner from "components/ReadyCTABanner";
import SubBanner from "@/components/SubBanner";
import JobSearch from "@/components/JobSearch";

// import JobSearch from "components/JobSearch";
// import MainBanner from "@/components/MainBanner";
// import SimpleFormWithColumn from "@/components/SimpleFormWithColumn";

import {
    Container,
} from 'reactstrap';

import { router } from "@/routes";
import { useLocale } from "@/hooks/useLocale";
/**
 *
 * @param global
 * @param meta
 * @returns {JSX.Element}
 * @constructor
 */
export default function Jobs({
    global,
    meta,
}) {
    const locale = useLocale();

    return (
        <>
            <SourceFlowHead
                metaObject={metaObject}
                title={meta.title}
                description={meta.description}
                canonical={meta.canonical}
            />
            <div className="bg-light-white">
                <SubBanner
                    global={global}
                    pathPrefix={`internal.all_jobs.page.sub_banner`}
                    heading={`Internal Job Search`}
                    content={<p>Looking for a new teaching role? Tradewind helps educators just like you to find their ideal classroom job.</p>}
                    breadcrumb_title={<><span className="active">Internal Job Search</span></>}
                    wave_color={`light-grey`}
                    showJobSearchInput={true}
                    className={`pt-4 jobs-page`}
                    waveIcon={false}
                />
                <JobSearch
                    global={global}
                    pathPrefix={`internal.all_jobs.page.job_search`}
                    // content_1={`Enter job title or location`}
                    all_jobs={true}
                    showJobSearchInput={true}
                    internal_jobs={true}
                />
                <ReadyCTABanner
                    global={global}
                    pathPrefix={`internal.all_jobs.page.ready_cta_banner`}
                    data-color={`light-grey`}
                />
            </div>
        </>
    );
}

/**
 *
 * @returns {Promise<{props: {meta: {description: string, canonical: string, title: string}, jobs: *, global}}>}
 */
export async function getStaticProps() {
    const global = (await Global()).toJson();

    const routerKey = "jobs.internal";

    return {
        props: {
            global,
            meta: {
                title: "Internal Job Search | Tradewind Subs",
                description: `${sourceflowEnums.seo.genericDescription}`,
                // canonical: sourceflowEnums.seo.baseURL,
                canonical: `${sourceflowEnums.seo.baseURL}${router[routerKey]["en"]}`,
                // alternate: { link: router[routerKey]["en"], lang: "en" },
            },
        },
    };
}

// -- Reference -- //
// https://github.com/sourceflow-uk/components/pkgs/npm/sourceflow-head
// https://github.com/sourceflow-uk/components/pkgs/npm/sourceflowtext
// https://github.com/sourceflow-uk/components/pkgs/npm/job-search